import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Place } from "../../types/place";
import EntityTable from "./../EntityTable";
import {
  extractPlaceEditLink,
  extractPlaceViewLink,
} from "./../entitiesReferences/InternalEntityLink";
import { renderRowViewAndUpdateActions } from "../../common/TableUtils";
import {
  placeTableColumns,
  placeFilterSpec,
} from "../../common/entities/PlaceColumns";
import usePlaceQuery from "../../hooks/query/usePlaceQuery";
import { MRT_ColumnDef } from "material-react-table";
import useServerFilters from "../../hooks/useServerFilters";

interface PlaceTableProps {
  columns?: MRT_ColumnDef<Place, any>[];
  filters?: Partial<Place>;
  enableRowActions?: boolean;
}

const PlaceTable: React.FC<PlaceTableProps> = ({
  columns = placeTableColumns,
  filters = {},
  enableRowActions = true,
}) => {
  const navigate = useNavigate();

  const {
    serverFilters,
    entityTableFilterProps,
    pagination,
    setPagination,
  } = useServerFilters(filters, placeFilterSpec);
  const { useFetchAll } = usePlaceQuery();
  const { data, isLoading, errorMessage } = useFetchAll({
    filters: serverFilters,
    externalPagination: pagination,
    externalSetPagination: setPagination,
  });

  const renderRowActions = useMemo(
    () =>
      renderRowViewAndUpdateActions(
        (place: Place) => navigate(extractPlaceViewLink(place)),
        (place: Place) => navigate(extractPlaceEditLink(place))
      ),
    [navigate]
  );

  return (
    <EntityTable
      loading={isLoading}
      error={errorMessage}
      columns={columns}
      renderRowActions={renderRowActions}
      enableRowActions={enableRowActions}
      data={data?.data || []}
      pagination={pagination}
      manualPagination={true}
      onPaginationChange={setPagination}
      totalRowCount={data?.total || 0}
      manualFiltering
      {...entityTableFilterProps}
    />
  );
};
export default PlaceTable;
